<template>
  <div class="pa-2">
    <section class="delivery-hierarchy-card">
      <draggable
        ref="drag"
        v-model="alocatedNfes"
        v-bind="dragOptions"
        multi-drag
        tag="div"
        selected-class="multi-drag"
        @add="onAdd"
      >
        <div class="pa-4">
          <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
            <div class="d-flex">
              <div v-if="!details" class="d-flex pr-1">
                <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold"> Entrega: </span>
                <span class="font-weight-regular"> {{ delivery?.deliveryNumber }} </span>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold">Destinatário: </span>
                <TruncateDataWithTooltip
                  :data="delivery.nameRecipient"
                  :lengthDataToTruncate="truncateLimit"
                ></TruncateDataWithTooltip>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold">Remetente: </span>
                <TruncateDataWithTooltip
                  :data="delivery.nameSender"
                  :lengthDataToTruncate="truncateLimit"
                ></TruncateDataWithTooltip>
              </div>
            </div>
            <div v-if="!details" class="d-flex justify-end">
              <v-icon v-if="isCollapsed" @click="isCollapsed = !isCollapsed">mdi-chevron-down</v-icon>
              <v-icon v-else @click="getNfesByDelivery(true)">mdi-chevron-right</v-icon>
              <v-icon class="ml-2" @click="openDeleteDialog(delivery.id)">mdi-close</v-icon>
            </div>
          </v-card-text>
          <v-card-text v-if="!details" class="d-flex pa-0" style="margin-left: 2px">
            <v-col class="pa-0" cols="12" md="12">
              <span class="font-weight-bold text--secondary">Valor das Mercadorias: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(delivery.totalPriceNfes) }}</span>
              <span class="font-weight-bold text--secondary">Peso: </span>
              <span class="font-weight-regular mr-4">{{ formatWeight(delivery.weight || 0) }}kg</span>
              <span class="font-weight-bold text--secondary">Quantidade de NFes: </span>
              <span class="font-weight-regular"> {{ delivery?.amountNfes }} </span>
            </v-col>
          </v-card-text>
        </div>
        <v-data-table
          id="list02"
          class="w-100"
          v-if="isCollapsed || details"
          :headers="nfeHeaders"
          :items="alocatedNfes"
          :items-per-page="alocatedNfes.length"
          :loading="isLoadingAlocated"
          loading-text="Carregando..."
          hide-default-footer
        >
          <template v-if="!details && alocatedNfes.length > 0" v-slot:[`header.select`]="{}">
            <v-checkbox hide-details v-model="selectAll" class="pa-0 ma-0 ml-6"></v-checkbox>
          </template>
          <template #body="{}">
            <drag-table-alocated
              v-model="alocatedNfes"
              :delivery="delivery"
              :selectAll="selectAll"
              :details="details"
              @update:allocatedNfes="unallocatedNfes"
              @update:selectAll="selectAll = $event"
              @loading:allocatedNfes="loadingAlocated"
            />
          </template>
        </v-data-table>
      </draggable>
    </section>

    <delete-confirm-dialog
      :isOpen.sync="isDeleteDialogOpen"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      @confirmClick="deleteDelivery"
      title="Desfazer Entrega"
      :body-text="confirmationText"
    />
  </div>
</template>

<script>
import DeleteConfirmDialog from '@/components/ConfirmDialog.vue';
import DragTableAlocated from '@/components/ManualBoardingImport/Stepper/Step2/DragTableAlocated.vue';
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import copyToClipboard from '@/utils/copyToClipboard';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';
import draggable from 'vuedraggable';

export default {
  components: {
    DeleteConfirmDialog,
    DragTableAlocated,
    TruncateDataWithTooltip,
    draggable
  },
  props: {
    delivery: {
      default: () => ({}),
      type: Object
    },
    details: {
      default: false,
      type: Boolean
    },
    selected: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isDeleteDialogOpen: false,
    isDeleteButtonLoading: false,
    isCollapsed: false,
    selectAll: false,
    deliveryIdToDelete: null,
    hasRequested: false,
    selectedNfe: {},
    alocatedNfes: [],
    dragOptions: {
      animation: 150,
      group: 'description',
      ghostClass: 'ghost',
      disabled: false,
      handle: 'none'
    }
  }),
  computed: {
    nfeHeaders() {
      const headers = [
        { value: 'number', text: 'NÚMERO NFE', sortable: true },
        { value: 'price', text: 'VALOR DA MERCADORIA', sortable: true },
        { value: 'weight', text: 'PESO', sortable: true },
      ];

      if (!this.details) {
        headers.unshift({ value: 'select', text: '', sortable: false });
      }

      return headers;
    },
    localSelected: {
      get() {
        return this.selected;
      },
      set() {
        this.$emit('update:selected', this.delivery.id);
      }
    },
    confirmationText() {
      if (this.getErrorNfeCount) {
        return 'Você confirma excluir essa entrega?';
      } else {
        return 'Confirmar dasalocar as NFes e excluir essa entrega?';
      }
    },
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    }
  },
  watch: {
    delivery: {
      handler(value) {
        if (this.details && value) {
          this.getNfesByDelivery();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('ImportManualDeliveryStore', ['getNfesByDeliveryId', 'allocateNfes']),
    async getNfesByDelivery(collapsed = false) {
      this.isLoadingAlocated = true;
      try {
        if (collapsed) {
          this.isCollapsed = !this.isCollapsed;
        }
        const data = await this.getNfesByDeliveryId(this.delivery.id || this.delivery.deliveryId);
        this.alocatedNfes = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingAlocated = false;
      }
    },
    loadingAlocated(loading) {
      this.alocatedNfes = [];
      this.isLoadingAlocated = loading;
    },
    openDeleteDialog() {
      this.isDeleteDialogOpen = true;
    },
    deleteDelivery() {
      this.$emit('removeDelivery', this.delivery.id);
      this.isDeleteDialogOpen = false;
    },
    unallocatedNfes(value, msg) {
      this.$emit('update:allocatedNfes', value, msg);
      this.getNfesByDelivery();
    },
    isLongText(text) {
      return text && text.length > this.truncateLimit;
    },
    truncateText(text) {
      return text && text.length > this.truncateLimit ? text.substring(0, this.truncateLimit - 3) + '...' : text;
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    },

    async onAdd(e) {
      this.loadingAlocated(true);
      if (e.item._selected_items.length > 1) {
        const draggedItems = e.item._selected_items;
        await this.allocateNfesToDelivery(draggedItems);
      } else {
        await this.allocateNfesToDelivery(e.item._underlying_vm_);
      }
      await this.loadingAlocated(false);
      await this.getNfesByDelivery();
      this.$emit('update:selectAll', false);
    },
    async allocateNfesToDelivery(nfes) {
      try {
        let nfeIds;
        if (Array.isArray(nfes)) {
          nfeIds = nfes.map(({ id }) => id);
        } else {
          nfeIds = [nfes.id];
        }
        const params = {
          id: this.delivery.id,
          nfeIds: nfeIds
        };

        const response = await this.allocateNfes(params);
        if (response.success) {
          this.unallocatedNfes('NFes alocadas com sucesso!', true);
        } else {
          const draggedItemIndex = this.alocatedNfes.findIndex((item) => item === nfes);
          this.alocatedNfes.splice(draggedItemIndex, 1);
          this.$emit(
            'update:allocatedNfes',
            response.errors[0] || 'NFes com destinatário ou remetente distintos!',
            false
          );
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style scoped>
* {
  transition: 0ms;
}
.ghost {
  display: none !important;
}
.multi-drag {
  border: #3a63af 10px solid;
}
.delivery-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.delivery-hierarchy-card-collapsed {
  width: 220px;
  height: 54px;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.checkbox-nfe {
  margin-top: 2px;
}
::v-deep .checkbox-nfe .v-input--selection-controls__input {
  margin-right: 0px;
}
</style>
